import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SmartSign } from 'site-modules/shared/components/profile/smart-sign/smart-sign';

import 'site-modules/shared/components/profile/profile.scss';
import './access-dashboard.scss';

export function AccessDashboard({ isAuthenticated = null }) {
  return (
    <div className={classNames('access-dashboard w-100', { 'dashboard-default-spacing': !isAuthenticated })}>
      {isAuthenticated === false && (
        <main id="main-content" tabIndex={-1}>
          <div
            className="access-dashboard-smart-sign my-1_5 mx-auto px-0_5 px-md-0"
            data-tracking-parent="edm-entry-access-dashboard"
          >
            <h1 className="size-30 text-gray-darker fw-bold d-md-inline-block me-md-1_5 mb-1_5 mb-md-1">
              My Dashboard
            </h1>
            <SmartSign />
          </div>
        </main>
      )}
    </div>
  );
}

AccessDashboard.propTypes = {
  isAuthenticated: PropTypes.bool,
};
